<template>
  <div class="pa-0">
    <v-card>
      <div class="d-flex justify-space-between align-items-center pb-0 pt-6 px-6">
        <h5 class=" text-uppercase align-self-center">Báo cáo giai đoạn chăm sóc</h5>
      </div>
      <v-card-text class="pa-6">
        <v-select
          item-text="title"
          item-value="value"
          placeholder="Nhân viên sale"
          v-model="defaultSaleUser"
          :items="formattedUsers"
          outlined
          dense
          hide-details
          @input="handleSelection"
          class="pa-0"
        />
        <PieChart :chartdata="pieChart" :options="pieChartOptions" class="align-self-center" />
        <div class="text-number align-self-center black--text">
          {{ statusCount.countAll }}
        </div>
        <div class="timeline-title align-self-center">
          Khách hàng tiềm năng
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import PieChart from './PieChart.vue'

export default {
  components: {PieChart},
  props: {
    users: Array,
    statusCount: Object
  },
  computed: {
    ...mapGetters('auth', ['user']),
    formattedUsers() {
      let options = this.users.map(u => ({title: u.name ? u.name : u.username, value: u.id}))
      if (this.user.role.type === 'admin') {
        options.unshift({title: 'Tất cả nhân viên', value: ''})
      }
      return options
    },
    defaultSaleUser() {
      return this.user && this.user.role.type === 'admin' ? '' : this.user ? this.user.id : null
    }
  },
  methods: {
    ...mapActions('lead', ['countStatus']),
    async getPieChartData() {
      return {
        labels: ['Chưa chăm sóc', 'Đã đặt lịch hẹn', 'Đã tư vấn', 'Đã nhập học', 'Thất bại'],
        datasets: [
          {
            backgroundColor: ['#BBDEFB', '#FFAB40', '#FFC107', '#4BCA81', '#FF1D30'],
            data: [
              this.statusCount.countNoContact,
              this.statusCount.countAppointmentSet,
              this.statusCount.countProductVerified,
              this.statusCount.countSucceed,
              this.statusCount.countFailed
            ]
          }
        ]
      }
    },
    async updatePieChart() {
      this.pieChart = await this.getPieChartData()
    },
    handleSelection(selectedValue) {
      this.$emit('selected', selectedValue)
    }
  },
  watch: {
    statusCount: {
      deep: true,
      handler() {
        this.updatePieChart()
      }
    }
  },
  data() {
    return {
      pieChartOptions: {responsive: true, maintainAspectRatio: false},
      pieChart: {},
      saleUser: ''
    }
  }
}
</script>

<style scoped>
.text-number {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 900;
  font-size: 28px;
  line-height: 33px;
  text-align: center;
}
.timeline-title {
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: #757575;
  text-align: center;
}
</style>
